(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/views/play-system-page.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/views/play-system-page.js');

'use strict';

svs.keno.views.PlaySystemPage = Marionette.View.extend({
  regions: {
    ngCampaignImageRegion: '#ngCampaignImageRegion',
    ngRowsContainerRegion: '#ngRowsContainerRegion',
    ngBetslipRegion: '#ngBetslipRegion',
    ngPayfooterRegion: '#ngPayfooterRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'keno',
    component: 'play'
  }],
  template(data) {
    return svs.keno.templates.play_page(data);
  },
  onRender() {
    if (svs.keno.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: svs.numbergames.productMapping.CONSTANTS.KENO,
        boards: 1,
        isSystem: true
      }, {
        storageKey: 'system',
        parse: true,
        hasTickets: svs.keno.data.hasTickets
      });
      this.showChildView('ngCampaignImageRegion', new svs.numbergames.game.views.CampaignImage({
        model
      }));
      this.showChildView('ngRowsContainerRegion', new svs.keno.components.play.views.SystemRowsContainer({
        model
      }));
      this.showChildView('ngBetslipRegion', new svs.keno.components.play.views.Betslip({
        model
      }));
      this.showChildView('ngPayfooterRegion', new svs.keno.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);